<template>
  <form>
    <md-card>
      <md-card-header data-background-color="green">
        <h4 class="title">
          #{{ ticketInfo.id }} - {{ ticketInfo.title }}
          <md-button
            class="md-icon-button md-list-action"
            style="float: right"
            :href="
              `https://sgi.green4t.com/plugins/os/front/osg4t.php?id=${ticketInfo.id}`
            "
          >
            <md-icon
              class="md-primary"
              style="height: 50px; width: 50px"
            >
              picture_as_pdf
            </md-icon>
          </md-button>
        </h4>
        <p
          v-if="!isUserReader || !isUserClient"
          class="category"
        >
          Preencha com a solução
        </p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field maxlength="5">
              <label>Data de Abertura{{
                isClosedTicket || isSolvedTicket ? "/Planejada" : ""
              }}</label>
              <md-input
                v-model="ticketInfo.date"
                type="datetime-local"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="!isUserReader || isClosedTicket || isSolvedTicket"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field maxlength="5">
              <label>{{
                isClosedTicket || isSolvedTicket
                  ? "Início do Atendimento"
                  : "Início do Atendimento Planejado"
              }}</label>
              <md-input
                v-model="ticketInfo.begin_date"
                type="datetime-local"
                :disabled="isClosedTicket || isSolvedTicket"
              />
            </md-field>
          </div>

          <div v-if="ticketInfo.slas_id_tto!='0'" 
            class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>SLA de início de Atendimento</label>
              <md-input
                v-model="ticketInfo.slas_id_tto"
                disabled
              />
            </md-field>
          </div>

          <div v-if="ticketInfo.slas_id_ttr!='0'" 
            class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>SLA para Solução</label>
              <md-input
                v-model="ticketInfo.slas_id_ttr"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="ticketInfo.time_to_own"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field maxlength="5">
              <label>Data limite para início de Atendimento</label>
              <md-input
                v-model="ticketInfo.time_to_own"
                type="datetime-local"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="ticketInfo.due_date"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field maxlength="5">
              <label>Data limite para Solução</label>
              <md-input
                v-model="ticketInfo.due_date"
                type="datetime-local"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="isClosedTicket || isSolvedTicket"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field maxlength="5">
              <label>Data de Solução</label>
              <md-input
                v-model="ticketInfo.solvedate"
                type="datetime-local"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>Tipo</label>
              <md-input
                v-model="ticketType"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="ticketInfo.category"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field>
              <label>Categoria</label>
              <md-input
                v-model="ticketInfo.category"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>Status</label>
              <md-input
                v-model="ticketStatus"
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="ticketInfo.origin"
            class="md-layout-item md-small-size-50 md-size-50"
          >
            <md-field>
              <label>Origem de Requisição</label>
              <md-input
                v-model="ticketInfo.origin"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>Modalidade</label>
              <md-input
                v-model="ticketModality"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>Prioridade</label>
              <md-input
                v-model="ticketPriority"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-50 md-size-50">
            <md-field>
              <label>Localização</label>
              <md-input
                v-model="ticketInfo.location"
                disabled
              />
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Descrição:</label>
              <md-textarea
                v-model="ticketInfo.content"
                md-autogrow
                disabled
              />
            </md-field>
          </div>

          <div
            v-if="
              !isUserReader &&
                (isClosedTicket || isSolvedTicket || !isUserClient)
            "
            class="md-layout-item md-size-100"
          >
            <md-field maxlength="5">
              <label>Solução:</label>
              <md-textarea
                v-model="ticketInfo.solution"
                md-autogrow
                :disabled="isClosedTicket || isSolvedTicket"
              />
            </md-field>
          </div>

          <div
            v-if="!isUserClient && !isClosedTicket && !isSolvedTicket"
            class="
              md-layout-item md-small-size-100 md-size-100
              add-technician-field
            "
          >
            <md-subheader>Horas Técnicas</md-subheader>
            <md-list slot="md-expand">
              <md-list-item
                v-for="item in technicians"
                :key="item.id"
                class="md-layout"
              >
                <md-icon class="md-layout-item md-size-10">
                  av_timer
                </md-icon>

                <div class="md-layout-item md-list-item-text md-size-30">
                  {{ item.name }}
                </div>

                <md-field class="md-layout-item md-size-30">
                  <md-input
                    v-model="item.date_begin"
                    type="datetime-local"
                  />
                </md-field>
                <md-field class="md-layout-item md-size-30">
                  <md-input
                    v-model="item.date_end"
                    type="datetime-local"
                  />
                </md-field>
              </md-list-item>
            </md-list>

            <div class="select-wrapper">
              <v-select
                v-model="selectedTechs"
                append-to-body
                multiple
                clearable
                label="name"
                :options="technicianList"
                :filterable="false"
                :clear-search-on-blur="() => true"
                @search="onSearchTech"
              >
                <template #no-options="{ search, searching }">
                  <template v-if="searching">
                    Não foram encontrados resultados para <em>{{ search }}</em>.
                  </template>
                  <em
                    v-else
                    style="opacity: 0.5"
                  >
                    Digite o nome do técnico desejado...
                  </em>
                </template>
              </v-select>
              <md-button
                class="md-icon-button"
                @click="addTech()"
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>
          </div>

          <div
            v-if="
              !isUserClient &&
                !isClosedTicket &&
                !isSolvedTicket &&
                consumablesList.length
            "
            class="md-layout-item md-small-size-100 md-size-100"
          >
            <md-subheader>Insumos Utilizados</md-subheader>

            <md-list :md-expand-single="true">
              <md-list-item
                v-for="([type, consumables], index) in consumablesList"
                :key="type"
                md-expand
                :md-expanded.sync="expandedConsumableType[index]"
                @click.prevent="toggleConsumableItemType(index)"
              >
                <p class="md-subheading md-list-item-text">
                  {{ type }}
                </p>

                <template
                  v-if="!expandedConsumableType[index]"
                  #md-expand
                >
                  <md-list>
                    <md-list-item />
                  </md-list>
                </template>

                <template
                  v-else
                  #md-expand
                >
                  <md-list>
                    <md-list-item
                      v-for="item in consumables"
                      :key="item.id"
                      class="md-inset"
                    >
                      <md-icon>scatter_plot</md-icon>
                      <div class="md-list-item-text">
                        {{ item.name }}
                          &nbsp;
                        {{ item.selected }}/{{ item.quantity }}
                      </div>
                      <md-button
                        class="md-icon-button md-list-action"
                        @click.stop="removeConsumable(item)"
                      >
                        <md-icon class="md-primary">
                          remove
                        </md-icon>
                      </md-button>
                      <md-button
                        class="md-icon-button md-list-action"
                        @click.stop="addConsumable(item)"
                      >
                        <md-icon class="md-primary">
                          add
                        </md-icon>
                      </md-button>
                    </md-list-item>
                  </md-list>
                </template>
              </md-list-item>
            </md-list>
          </div>

          <div
            v-if="
              !isUserReader &&
                !isUserClient &&
                !isClosedTicket &&
                !isSolvedTicket
            "
            class="md-layout-item md-size-100 text-right"
          >
            <md-button
              class="md-raised md-success text-uppercase"
              :disabled="submitButtonDisabled"
              @click="submitForm()"
            >
              Atualizar chamado
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
import debounce from "lodash.debounce";

import { DateTime } from "luxon";

import { userService } from "../../_services";
import { removeConsumablesFromStock } from "../../_services/consumable.service";
import { getUserSession } from "../../_services/localstorage";

import { isUserClient } from "../../util/is-user-client";
import { isUserReader } from "../../util/is-user-reader";
import { DateTimeFormats } from "../../util/datetime.formats";
import { ROUTES } from "../../routes/routes";

const NOTIFICATION_MESSAGES = {
  SUCCESS: "Chamado Atualizado com sucesso",
  ERROR: "Não foi possível atualizar o chamado",
};

export default {
  name: "OpenTicketForm",
  props: {
    currentStep: {
      type: Number,
      default: () => 0,
    },
    ticketInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      user: null,

      types: [],
      technicians: [],
      technicianList: [],
      selectedTechs: null,

      submitButtonDisabled: false,

      usersCategoriesMap: new Map(),
      consumableTypesMap: new Map(),
      consumableChangeTracker: 1,

      expandedConsumableType: [],
    };
  },
  computed: {
    consumablesList() {
      return (
        this.consumableChangeTracker &&
        Array.from(this.consumableTypesMap.entries())
      );
    },
    isClosedTicket() {
      return this.ticketInfo.status === 6;
    },
    isSolvedTicket() {
      return this.ticketInfo.status === 5;
    },
    isUserReader() {
      return isUserReader(this.user);
    },
    isUserClient() {
      return isUserClient(this.user);
    },
    ticketType() {
      const type = this.user.typeOption.find(
        ({ id }) => id === this.ticketInfo.type,
      ) || {
        name: "",
      };

      return type.name;
    },
    ticketStatus() {
      const status = this.user.statusOption.find(
        ({ id }) => id === this.ticketInfo.status,
      ) || {
        name: "",
      };

      return status.name;
    },
    ticketModality() {
      const modality = this.user.modalityOptions.find(
        ({ id }) => id === this.ticketInfo.modality,
      ) || {
        name: "",
      };

      return modality.name;
    },
    ticketPriority() {
      const priority = this.user.urgencyOptions.find(
        ({ id }) => id === this.ticketInfo.priority,
      ) || {
        name: "",
      };

      return priority.name;
    },
  },
  async created() {
    this.loading = true;

    this.returnUrl = "/activities";
    this.user = getUserSession();

    if (!this.isUserClient && !this.isClosedTicket && !this.isSolvedTicket) {
      // Get User Categories
      const usersCategories = await userService.getUserCategoriesCost();
      this.usersCategoriesMap = new Map(
        usersCategories.map(category => [category.id, category.cost]),
      );

      const { techsIds } = await userService.getTechniciansFromTicket(
        this.ticketInfo.id,
      );
      const now = DateTime.now().toFormat(DateTimeFormats.HTML_INPUT_DATETIME);
      for (const techId of techsIds) {
        const techData = await userService.getUserInfo(this.user.token, techId);
        this.technicians.push({
          id: techData.id,
          name: `${techData.firstname} ${techData.realname}`,
          title: techData.usertitles_id,
          date_begin: this.ticketInfo.begin_date,
          date_end: now,
        });
      }

      if (
        this.user.materialsPresentation &&
        this.user.materialsPresentation === "presented"
      ) {
        const { data } = await userService.searchConsumableItem(
          this.user.token,
        );

        data.forEach(consumable => {
          if (!this.consumableTypesMap.has(consumable.type)) {
            return this.consumableTypesMap.set(consumable.type, [consumable]);
          }

          const consumables = this.consumableTypesMap.get(consumable.type);
          consumables.push(consumable);
          this.consumableChangeTracker++;
        });
      }
    }

    this.loading = false;
  },
  methods: {
    async submitForm() {
      this.$progress.start();
      this.submitButtonDisabled = true;

      const { value, status, redirect } = await this.submitFormRequests();

      this.$progress.stop();
      this.submitButtonDisabled = false;

      this.$notify({
        message: value,
        timeout: 2000,
        type: status === "error" ? "danger" : "success",
      });

      if (redirect) {
        this.$router.push({ name: ROUTES.ACTIVITIES });
      }
    },
    async submitFormRequests() {
      if (!this.ticketInfo.solution) {
        // this only updates begin_date, refactor this :D
        await userService.updateTicket(
          this.user.token,
          this.ticketInfo.id,
          this.ticketInfo,
        );

        return { value: NOTIFICATION_MESSAGES.SUCCESS, status: "success" };
      }

      let materials = "| ";
      const tasksInput = [];
      const ticketUserInput = [];

      const selectedConsumables = Array.from(this.consumableTypesMap.values())
        .reduce((acc, curr) => acc.concat(curr), [])
        .filter(consumableItem => consumableItem.selected > 0);

      const costsInput = selectedConsumables.map(consumableItem => {
        const comment = `${consumableItem.selected}x (${consumableItem.id}) ${consumableItem.name}`;
        materials += `${comment} | `;

        return {
          tickets_id: this.ticketInfo.id,
          name: comment,
          comment: "-",
          actiontime: 0,
          cost_time: 0,
          cost_fixed: 0,
          cost_material: consumableItem.value,
        };
      });

      for (const tech of this.technicians) {
        const dateBegin = DateTime.fromFormat(
          tech.date_begin,
          DateTimeFormats.HTML_INPUT_DATETIME,
        );
        const dateEnd = DateTime.fromFormat(
          tech.date_end,
          DateTimeFormats.HTML_INPUT_DATETIME,
        );
        const actionTime = dateEnd.diff(dateBegin).as("seconds");
        const techCost = this.usersCategoriesMap.get(tech.title) || 0;

        // Add ticket Tasks
        tasksInput.push({
          tickets_id: this.ticketInfo.id,
          users_id: tech.id,
          users_id_tech: tech.id,
          content: "ACOMPANHAMENTO",
          tasktemplates_id: 88,
          taskcategories_id: 9,
          state: 2,
          actiontime: actionTime,
          begin: dateBegin.toFormat(DateTimeFormats.GLPI_DATETIME),
          end: dateEnd.toFormat(DateTimeFormats.GLPI_DATETIME),
        });

        // Add ticket Cost
        costsInput.push({
          tickets_id: this.ticketInfo.id,
          name: `Atividade de ${tech.name}`,
          comment: "-",
          actiontime: actionTime,
          cost_time: techCost,
          cost_fixed: 0,
          cost_material: 0,
        });

        // Add ticket users
        ticketUserInput.push({
          tickets_id: this.ticketInfo.id,
          users_id: tech.id,
          type: 2,
        });
      }

      const bulkRequests = [];
      if (costsInput.length) {
        bulkRequests.push(
          () => userService.postObject(this.user.token, "TicketCost", {
            input: costsInput,
          }),
        );
      }
      if (tasksInput.length) {
        bulkRequests.push(
          () => userService.postObject(this.user.token, "TicketTask", {
            input: tasksInput,
          }),
        );
      }
      if (ticketUserInput.length) {
        bulkRequests.push(
          () => userService.postObject(this.user.token, "Ticket_User", {
            input: ticketUserInput,
          }),
        );
      }
      if (selectedConsumables.length) {
        bulkRequests.push(
          () => removeConsumablesFromStock(
            selectedConsumables.map(consumable => ({
              id: consumable.id,
              quantity: consumable.selected,
            })),
          ),
        );
      }

      await Promise.allSettled([
        userService.AddTicketFollowUp(
          this.user.token,
          this.ticketInfo.id,
          `Tecnico Atribuido: (${this.user.id}) ${this.user.name} | Solucao: ${this.ticketInfo.solution}`,
        ),
        ...bulkRequests.map(fn => fn()),
      ]);

      const [
        { status: solutionStatus },
        { status: ticketUpdateStatus }
      ] = await Promise.allSettled([
        userService.postObject(this.user.token, "ITILSolution", {
          input: {
            items_id: this.ticketInfo.id,
            content: this.ticketInfo.solution,
            itemtype: "Ticket",
          },
        }),
        userService.solveTicket(
        this.user.token,
        this.ticketInfo.id,
        this.ticketInfo.solution,
        materials,
        this.ticketInfo,
        ),
      ]);

      if (solutionStatus !== "fulfilled" || ticketUpdateStatus !== "fulfilled") {
        return { value: NOTIFICATION_MESSAGES.ERROR, status: "error" };
      }

      return {
        value: NOTIFICATION_MESSAGES.SUCCESS,
        status: "success",
        redirect: true,
      };
    },
    addConsumable(consumable) {
      if (consumable.selected < consumable.quantity) {
        consumable.selected++;
        this.consumableChangeTracker++;
      }
    },
    removeConsumable(consumable) {
      if (consumable.selected > 0) {
        consumable.selected--;
        this.consumableChangeTracker++;
      }
    },
    onSearchTech(searchTerm, loadingFn) {
      this.technicianList = [];
      if (searchTerm.length) {
        loadingFn(true);
        this.fetchTechList(this, searchTerm, loadingFn);
      }
    },
    fetchTechList: debounce(async (context, searchTerm, loadingFn) => {
      context.technicianList = await userService.getTechniciansByName(
        searchTerm,
      );
      loadingFn(false);
    }, 350),
    addTech() {
      const techs = this.selectedTechs.map(tech => ({
        ...tech,
        date_begin: this.ticketInfo.begin_date,
        date_end: DateTime.now().toFormat(DateTimeFormats.HTML_INPUT_DATETIME),
      }));

      this.technicians.push(...techs);
      this.selectedTechs = [];
    },
    toggleConsumableItemType(index) {
      this.expandedConsumableType[index] = !Boolean(this.expandedConsumableType[index]);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-technician-field {
  .select-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    .v-select {
      flex-grow: 1;
    }

    .md-icon-button {
      border-radius: 50%;
      padding: 10px;
      margin: 0;
    }
  }
}
</style>
